import type { CSSProperties } from "react";

// Shimmery placeholder block used throughout while data is loading.
// The `.ash-skeleton` class lives in index.css and supplies the keyframes
// + colour-stops; this component just sizes and labels it.
type Props = {
  width?: number | string;
  height?: number | string;
  className?: string;
  rounded?: "card" | "full" | "default";
  style?: CSSProperties;
};

const roundedClasses: Record<NonNullable<Props["rounded"]>, string> = {
  card: "rounded-card",
  full: "rounded-full",
  default: "",
};

export function Skeleton({
  width = "100%",
  height = 12,
  className = "",
  rounded = "default",
  style,
}: Props) {
  return (
    <div
      aria-hidden="true"
      className={`ash-skeleton ${roundedClasses[rounded]} ${className}`.trim()}
      style={{ width, height, ...style }}
    />
  );
}
